// extracted by mini-css-extract-plugin
export default {"currency-symbol":"C-5d9-IkEr-Tin9cyKdhLA=="};